module.exports = __webpack_public_path__ + "img/kakao.dc9b2fac.svg";